<template>
  <section class="delivery_settings">
    <reservation-delivery-type></reservation-delivery-type>

    <delivery-details v-if="deliveryType === 'delivery'"></delivery-details>

    <div v-if="deliveryType === 'pickup'">
      <address-search-with-google></address-search-with-google>
      <google-maps></google-maps>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AddressSearchWithGoogle from '../AddressSearchWithGoogle.vue'
import GoogleMaps from '../GoogleMap.vue'
import ReservationDeliveryType from './ReservationDeliveryType.vue'
import DeliveryDetails from './ReservationDeliveryDetails.vue'

export default {
  name: 'ReservationDeliverySettings',
  components: {
    AddressSearchWithGoogle,
    GoogleMaps,
    ReservationDeliveryType,
    DeliveryDetails,
  },
  computed: {
    ...mapState('user', ['address']),
    ...mapState('cart', ['orderChildStep', 'deliveryType']),
    ...mapGetters('cart', {
      status: 'childStatus',
    }),
  },
}
</script>

<style lang="scss" scoped>
section.delivery_settings {
  width: 100%;
}
</style>
